import { render, staticRenderFns } from "./messager.vue?vue&type=template&id=d54820b6&"
import script from "./messager.vue?vue&type=script&lang=js&"
export * from "./messager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports